import { createEntityMutation } from '../../createEntityMutation';
import {
  WaterfallService,
  type Wealthlane_CapTable_Dtos_Waterfall_WaterfallReportDto,
  type Wealthlane_CapTable_Dtos_Waterfall_WaterfallRequestDto,
} from '@wealthlane/api-services/wealthlane-captable-service';

export const WATERFALL_ROW_KIND = {
  Preferred: 1,
  Common: 2,
  Options: 3,
  Rsu: 4,
  Convertibles: 5,
  Warrants: 6,
  Psu: 7,
} as const;

export type WaterfallRequestDto = Wealthlane_CapTable_Dtos_Waterfall_WaterfallRequestDto & {
  hideUnderwaterOptions?: boolean;
};

export type WaterfallHolderRowDto = {
  participantId?: string;
  participantName?: string | null;
  role?: string | null;
  shares?: number;
  ownershipPercent?: number;
  totalPaidAmount?: number;
  exitPercent?: number;
  strikePrice?: number | null;
  isUnderwater?: boolean;
  vestedShares?: number;
};

export type WaterfallClassRowDto = NonNullable<
  Wealthlane_CapTable_Dtos_Waterfall_WaterfallReportDto['rows']
>[number] & {
  kind?: number;
  holders?: WaterfallHolderRowDto[] | null;
};

export type WaterfallReportDto = Omit<
  Wealthlane_CapTable_Dtos_Waterfall_WaterfallReportDto,
  'rows'
> & {
  optionsTotalAmount?: number;
  rsuTotalAmount?: number;
  psuTotalAmount?: number;
  warrantsTotalAmount?: number;
  rows?: WaterfallClassRowDto[] | null;
};

export function isStrikeInstrumentKind(kind?: number): boolean {
  return kind === WATERFALL_ROW_KIND.Options || kind === WATERFALL_ROW_KIND.Warrants;
}

export function isVestedAwardKind(kind?: number): boolean {
  return (
    kind === WATERFALL_ROW_KIND.Options ||
    kind === WATERFALL_ROW_KIND.Warrants ||
    kind === WATERFALL_ROW_KIND.Rsu ||
    kind === WATERFALL_ROW_KIND.Psu
  );
}

export const usePostWaterfallCalculate = createEntityMutation<WaterfallReportDto, WaterfallRequestDto>({
  mutationFn: (payload) => WaterfallService.postApiCapTableApiAppWaterfallCalculate(payload),
});
